const baseURL = "/v1/Administracao/GreMunicipios";

const service = {
  methods: {
    $buscarGreMunicipios(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $buscarGreMunicipiosPorPermissao() {
      return this.$api().get(`${baseURL}PorPermissao`);
    },
  }
}

export default service;